import ButtonLink from "@/Components/ButtonLink";
import Image from "next/image";
import React from "react";
import Style from "./ServicesCard.module.scss"; // Assuming you have a CSS module for styles

interface ServicesCardProps {
  number: string;
  title: string;
  details: string;
  link: string;
  label: string;
  image?: string;
  imageHover?: string;
  reverse?: boolean;
  isMobile?: boolean;
}

const ServicesCard: React.FC<ServicesCardProps> = ({
  number,
  title,
  details,
  link,
  label,
  image,
  imageHover,
  reverse = false,
  isMobile,
}) => {
  return (
    <div
      className={`flex lg:border-b-0 border-b-[1px] border-border lg:flex-nowrap flex-wrap ${
        reverse ? "flex-row-reverse" : "flex-row"
      } lg:gap-[30px] gap-0 items-stretch group ${Style.hoverServicesMain}`}
    >
      {/* Number Column */}
      <div
        className={`lg:border-b-[1px] border-b-0 border-t-[1px] ${
          reverse ? "border-r-[1px]" : "border-l-[1px]"
        } border-border overflow-hidden lg:w-[180px] md:w-[125px] w-[81px] flex-[0_0_auto]`}
      >
        <p
          className={`lg:text-[217px] md:text-[158px] text-display text-blue-50 md:pt-0 pt-3
            lg:leading-[283px] md:leading-[205px] leading-[46px] uppercase 
            lg:tracking-[-21px] md:tracking-[-15px] tracking-[-1px] 
            ${
              reverse
                ? "text-right md:translate-x-[-34%] translate-x-[6%]"
                : "text-left md:translate-x-[-34%] translate-x-[-10%]"
            } `}
        >
          {number}
        </p>
      </div>

      {/* Text + Mobile Image */}

      <div
        className={`lg:py-8 md:py-6 py-4 lg:px-8 md:px-[23px] lg:pr-0 lg:border-b-[1px] border-t-[1px] border-border lg:w-auto w-full lg:block gap-5 flex items-start ${
          reverse ? "lg:pl-5 flex-row-reverse" : "lg:pr-5 flex-row"
        }`}
      >
        <div>
          <p className="xl:text-heading-4 text-heading-5 font-bold text-secondary-text">
            {title}
          </p>
          <p className="xl:text-subtitle-2 text-subtitle-4 font-semibold text-secondary-text lg:mt-6 mt-4">
            {details}
          </p>
          {link && label && (
            <ButtonLink
              label={label}
              href={link}
              className="lg:mt-7 mt-[17.4px] xl:text-subtitle-2 text-subtitle-4"
              color="text-primary-text"
              stroke="stroke-primary-text"
            />
          )}
        </div>

        {/* Mobile Image */}

        <div
          className={`lg:hidden flex items-center justify-center overflow-hidden xl:w-[285px] lg:w-[198px] w-[80px] aspect-[285/200] flex-[0_0_auto] relative lg:h-auto lg:border-b-[1px] border-b-0 border-t-[1px] ${
            reverse ? "lg:border-l-[1px]" : "lg:border-r-[1px]"
          } border-border
            before:transition-all before:duration-300
            before:bg-[url(/images/noise-graphics.png)] before:content-[''] before:absolute before:w-full before:h-full before:top-0 before:left-0 before:bg-cover before:bg-no-repeat before:bg-center before:opacity-100 xl:before:opacity-0 group-hover:before:opacity-100 ${Style.hoverServicesBg}`}
        >
          <div className="bg-[url(/images/SSM-graphics.png)] bg-center bg-contain bg-no-repeat relative z-10 w-full h-full">
            <Image
              src={imageHover || ""}
              alt={title}
              // fill
              height={52}
              width={80}
              className=" min-h-[52px] max-h-[52px] object-cover object-center transition-all duration-300 hover-services-up"
              quality={100}
            />
          </div>
        </div>
      </div>

      {/* Desktop Image */}
      {!isMobile && (
        <div
          className={`lg:flex hidden items-center justify-center overflow-hidden xl:w-[285px] lg:w-[198px] w-[80px] xl:aspect-[285/200] aspect-[198/231] flex-[0_0_auto] relative lg:h-auto h-full ${
            reverse ? "lg:border-l-[1px]" : "lg:border-r-[1px]"
          } lg:border-b-[1px] border-b-0 border-t-[1px] border-border
            before:transition-all before:duration-300
            before:bg-[url(/images/noise-graphics.png)] before:content-[''] before:absolute before:w-full before:h-full before:top-0 before:left-0 before:bg-cover before:bg-no-repeat before:bg-center group-hover:before:opacity-100 ${Style.hoverServicesBg}`}
        >
          <div
            className={`bg-[url(/images/SS-graphics.png)] bg-center bg-contain bg-no-repeat relative z-10 w-full h-full `}
          >
            <Image
              src={imageHover || ""}
              alt={title}
              // height={328}
              // width={285}
              fill
              // className="object-cover opacity-100 transition-all grayscale group-hover:grayscale-0  duration-300 hover-services-up"

              className={`xl:object-cover object-contain object-center transition-all duration-300 ${Style.hoverServicesDefult}`}
              quality={100}
            />
            <Image
              src={image || ""}
              alt={title}
              // height={328}
              // width={285}
              fill
              // className="object-cover opacity-100 transition-all grayscale group-hover:grayscale-0  duration-300 hover-services-up"

              className={`xl:object-cover object-contain object-center transition-all duration-300 ${Style.hoverServicesHover}`}
              quality={100}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ServicesCard;
